export default "__VITE_ASSET__VOvBTrZ1__"